import Axios, { type AxiosError, type AxiosRequestConfig, type AxiosResponse } from 'axios';
import { error as onError, success as onSuccess } from 'shared/notifications';
import apiService from 'shared/service/api.service';

const { baseUrl } = apiService;

// #region Callbacks

const onFulfilled = (
  response: AxiosResponse<any>,
): AxiosResponse<any> | Promise<AxiosResponse<any>> => {
  if (response?.data?.message) {
    onSuccess({
      data: response.data.message,
    });
  }
  return response;
};

const onRejected = (error: AxiosError<any> | Error): Promise<never> => {
  if (Axios.isAxiosError(error)) {
    onError({
      data:
        // @ts-expect-error
        error.response?.data?.error_message ||
        // @ts-expect-error
        error.response?.data?.message ||
        error.response?.statusText,
    });
  }
  return Promise.reject(error);
};

// #endregion

// #region Instances

export const ORVAL_AXIOS_INSTANCE = Axios.create({
  baseURL: baseUrl,
});

ORVAL_AXIOS_INSTANCE.interceptors.response.use(onFulfilled, onRejected);

export const customInstance = <T>(
  { headers, ...config }: AxiosRequestConfig,
  _opt: any,
): Promise<T> => {
  const promise = ORVAL_AXIOS_INSTANCE({
    headers: {
      ...headers,
      tenant: apiService.tenant,
    },
    ...config,
  }).then(({ data }) => data);

  return promise;
};

// #endregion

export interface ErrorType<Error> extends AxiosError<Error> {}
